enum Statuses {
    ACTIVE = "active",
    LOCKED = "locked",
    CANCELLED = "cancelled",
    DEBTOR = "debtor",
    DISABLE = "disabled",
    DEACTIVATED = "deactivated",
  }
  
export { Statuses };